import { FilteredItemProps } from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { DateRangeFilterModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/core/src/models/inputs/date-range-filter.model';
import { useTranslation } from 'react-i18next';

import { DateRangeFilterStateController } from '@shared/filter/date-range-filter/date-range-filter-state.controller';

export interface ChannelListLastMessageReceivedDateFilterStateControllerProps {
  value: DateRangeFilterModel;
  onRemove: FilteredItemProps['onRemove'];
}

export const ChannelListLastMessageReceivedDateFilterStateController = ({
  value,
  onRemove,
}: ChannelListLastMessageReceivedDateFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <DateRangeFilterStateController
      icon="calendar-date"
      fromLabel={t('$.channel-list-last-message-received-date-filter.from')}
      toLabel={t('$.channel-list-last-message-received-date-filter.to')}
      value={value}
      onRemove={onRemove}
    />
  );
};
